import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c31ba1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistical-dept-page" }
const _hoisted_2 = {
  class: "statitiscal",
  "aria-label": "访问汇总"
}

import { computed, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { Download } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import {
  isSupersededRequestError,
  useLatestRequest
} from '@/hooks/crud/useLatestRequest'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import type { CrudSelectOption } from '@/types/crud-config'
import {
  createStatisticalDeptSearchItems,
  statisticalDeptTableColumns
} from './statistical-dept.config'
import {
  exportStatisticalDept,
  fetchStatisticalDeptChannels,
  fetchStatisticalDeptPage,
  fetchStatisticalDeptSummary
} from './statistical-dept.service'
import type {
  StatisticalDeptFilters,
  StatisticalDeptRecord,
  StatisticalDeptSummary
} from './statistical-dept.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalDept',
  setup(__props) {

const store = useStore()
const router = useRouter()
const canList = usePermission('liveStatisticalDept', 'list')
const canDownload = usePermission('liveStatisticalDept', 'download')

function createFilters(): StatisticalDeptFilters {
  return {
    channelId: '',
    deptId: store.state.login.userInfo.deptId,
    accessTime: [
      dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ]
  }
}

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  lastSuccessfulQuery,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({ createFilters, fetchPage: fetchStatisticalDeptPage })

const summaryRequest = useLatestRequest()
const channelOptions = ref<CrudSelectOption[]>([])
const optionsLoading = ref(false)
const exporting = ref(false)
const summary = ref<StatisticalDeptSummary>({ pv: 0, uv: 0, ip: 0 })

const departmentOptions = computed<CrudSelectOption[]>(() =>
  store.state.login.depts.map(
    (item: { id: string | number; name: string }) => ({
      label: item.name,
      value: item.id
    })
  )
)
const searchItems = computed(() =>
  createStatisticalDeptSearchItems(
    channelOptions.value,
    departmentOptions.value,
    optionsLoading.value
  )
)
const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

async function queryWithSummary(action: () => Promise<boolean>) {
  summaryRequest.cancel()
  summary.value = { pv: 0, uv: 0, ip: 0 }
  const succeeded = await action()
  if (!succeeded || !lastSuccessfulQuery.value) return

  try {
    summary.value = await summaryRequest.run((signal) =>
      fetchStatisticalDeptSummary(lastSuccessfulQuery.value!.filters, signal)
    )
  } catch (cause) {
    if (isSupersededRequestError(cause)) return
    ElMessage.error(cause instanceof Error ? cause.message : '汇总数据加载失败')
  }
}

async function loadChannels() {
  optionsLoading.value = true
  try {
    channelOptions.value = (await fetchStatisticalDeptChannels()).map(
      (item) => ({
        label: item.eventName,
        value: item.rowId
      })
    )
  } catch (cause) {
    ElMessage.error(
      cause instanceof Error ? cause.message : '直播间选项加载失败，请稍后重试'
    )
  } finally {
    optionsLoading.value = false
  }
}

function openAccessRecords(row: StatisticalDeptRecord) {
  const accessTime = lastSuccessfulQuery.value?.filters.accessTime
  if (!accessTime) return
  router.push({
    path: '/main/live/record',
    query: {
      deptId: String(row.deptId),
      accessTime
    }
  })
}

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

async function download() {
  if (!lastSuccessfulQuery.value) return
  exporting.value = true
  try {
    saveBlob(
      await exportStatisticalDept(lastSuccessfulQuery.value),
      '直播访问记录表-按部门.xlsx'
    )
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '导出失败')
  } finally {
    exporting.value = false
  }
}

onMounted(() => {
  loadChannels()
  if (canList) queryWithSummary(load)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading) || _unref(summaryRequest).isPending.value,
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (queryWithSummary(_unref(search)))),
      onReset: _cache[1] || (_cache[1] = ($event: any) => (queryWithSummary(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("总访问次数(pv): "),
        _createElementVNode("em", null, _toDisplayString(summary.value.pv), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("客户数量(uv): "),
        _createElementVNode("em", null, _toDisplayString(summary.value.uv), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("独立ip: "),
        _createElementVNode("em", null, _toDisplayString(summary.value.ip), 1)
      ])
    ])), [
      [_directive_loading, _unref(summaryRequest).isPending.value]
    ]),
    _createVNode(_unref(CrudTable), {
      "row-key": "deptId",
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(statisticalDeptTableColumns),
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRowClick: openAccessRecords,
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _createTextVNode("访问记录")
      ]),
      actions: _withCtx(() => [
        (_unref(canDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: exporting.value,
              disabled: !_unref(lastSuccessfulQuery),
              onClick: download
            }, {
              default: _withCtx(() => [
                (!exporting.value)
                  ? (_openBlock(), _createBlock(_unref(Download), {
                      key: 0,
                      class: "statistical-dept-page__button-icon",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" 下载 ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns", "onPageChange", "onPageSizeChange", "onRetry"])
  ]))
}
}

})